/*global Zenbox*/
import React, { Component } from 'react';
import { AuthStore } from 'stores';

class Help extends Component {

  componentDidMount() {
    if (typeof Zenbox !== 'undefined') {
      let User = AuthStore.getUser();
      Zenbox.init({
        dropboxID: '20297068',
        url: 'https://coursio.zendesk.com/',
        tabTooltip: 'Help',
        tabImageURL:
          'https://assets.zendesk.com/external/zenbox/images/tab_help_right.png',
        tabColor: '#1abc9c',
        tabPosition: 'Right',
        requester_name: User.displayName,
        requester_email: User.email,
        hide_tab: 'true'
      });

      Zenbox.show();

      const { router } = this.props;
      router.push('/');
    }
  }

  render() {
    return <div />;
  }
}

export default Help;



// WEBPACK FOOTER //
// ./src/js/components/Route/Help.js